export default defineNuxtRouteMiddleware(async (to) => {
  const shouldReloadAppOnPageLeave = useShouldReloadAppOnPageLeave()

  const { userProfile, getUserProfile, followeesIds, getFolloweesIds, isAuthenticated, getToken } = useAuthStore()
  const webAuth = useCookie('web-auth', { domain: useCookiesDomain() })
  await getToken()

  if (shouldReloadAppOnPageLeave.value) {
    return navigateTo(to, { external: true })
  }

  if (to.name === undefined) {
    return navigateTo('/')
  }

  if (isAuthenticated.value) {
    if (webAuth.value) {
      webAuth.value = null
    }

    if (!userProfile.value || !followeesIds.value) {
      await Promise.all([
        getUserProfile(),
        getFolloweesIds()
      ])
    }
  }
})
